import api from '../utils/api';

export const getAllRetailerByCommercial = async () => {
  try {
    const response = await api.get('/partner/retailers/commercial');
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to fetch retailers');
  }
};
